import { render, staticRenderFns } from "./FormToggle.vue?vue&type=template&id=a201d51e&"
import script from "./FormToggle.vue?vue&type=script&lang=js&"
export * from "./FormToggle.vue?vue&type=script&lang=js&"
import style0 from "./FormToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports